import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './containers/App';
import './i18n';
import 'rc-steps/assets/index.css';

ReactDOM.render(
  React.createElement(
    Provider,
    { store },
    React.createElement(App, null)
  ),
  document.getElementById('root')
);